import React from 'react';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  htmlFor: string;
  children: React.ReactNode;
  className?: string;
}

// Keep the old interface for backward compatibility - using type alias instead
type FormLabelProps = LabelProps;

function FormLabel({ htmlFor, children, className = '', ...props }: FormLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-sm font-medium text-gray-700 dark:text-gray-200 ${className}`}
      {...props}
    >
      {children}
    </label>
  );
}

// Alias for consistency with index.ts
const Label = FormLabel;
export default Label;
